import { legalVersionSchema } from "@/features/legal/version";
import { appLinksSchema, canonicalAppLinkUrl } from "./links";
import { storeLink } from "@/features/shares/store-link";
import { z } from "zod/v4";
import { apiFetch } from "@/lib/apiClient";
export const appInfoSchema = z.object({
  maintenanceMode: z.boolean(), maintenanceMessage: z.string(), apiDisabled: z.boolean(), minimumVersion: z.string(),
  links: appLinksSchema,
  legalVersion: legalVersionSchema.nullable(),
});
export async function getAppInfo(signal?: AbortSignal) {
  return appInfoSchema.parse(await apiFetch("/app-info", { signal }));
}

// Public presentation names for known IDs; custom links keep their server name.
const linkLabels: Record<string, { name: string; icon: string }> = {
  openai: { name: "OpenAI plugin / app", icon: "robot-outline" },
  anthropic: { name: "Anthropic marketplace / connector", icon: "robot-outline" },
  mcp: { name: "MCP server", icon: "server-network" },
  github: { name: "GitHub", icon: "github" },
  vscode: { name: "Visual Studio Marketplace", icon: "microsoft-visual-studio-code" },
  cursor: { name: "Cursor", icon: "cursor-default" },
};
export async function getAppLinks(signal?: AbortSignal) {
  const body = await getAppInfo(signal);
  return {
    ios: storeLink(body.links.find(link => link.id === "ios")?.url, "ios"),
    android: storeLink(body.links.find(link => link.id === "android")?.url, "android"),
    integrations: body.links.filter(link => link.id !== "ios" && link.id !== "android").flatMap(link => {
      const url = canonicalAppLinkUrl(link);
      return url ? [{ ...link, url, name: link.platform?.trim() || linkLabels[link.id]?.name || link.id, icon: linkLabels[link.id]?.icon ?? "link-variant" }] : [];
    }),
  };
}
